import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import "../../styles/adminHoroscope.css";

export default function AdminHoroscopePanel() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get("/api/admin/horoscopes")
      .then((res) => {
        if (res.data?.ok) setItems(res.data.rows || []);
      })
      .catch((err) => console.error("Failed to load horoscopes", err))
      .finally(() => setLoading(false));
  }, []);

  const openItem = (item) => {
    setActive(item);
    setContent(item?.content || "");
  };

  const saveItem = async () => {
    if (!active) return;
    setSaving(true);
    try {
      const { data } = await api.put(`/api/admin/horoscopes/${active.id}`, {
        content,
      });
      if (!data?.ok) throw new Error(data?.message || "Save failed");

      // update list in memory so it reflects immediately
      setItems((prev) =>
        prev.map((it) => (it.id === active.id ? { ...it, content } : it))
      );

      alert("Horoscope saved successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to save horoscope");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-horoscope">
      {/* LEFT LIST */}
      <div className="admin-horoscope-list">
        <h3>Horoscope Articles</h3>

        {loading && <p>Loading…</p>}
        {!loading && items.length === 0 && <p>No horoscope articles found.</p>}

        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`admin-horoscope-item ${
              active?.id === item.id ? "active" : ""
            }`}
            onClick={() => openItem(item)}
          >
            <strong>{item.zodiac}</strong>
            <span>{item.title}</span>
          </button>
        ))}
      </div>

      {/* RIGHT EDITOR */}
      <div className="admin-horoscope-editor">
        {!active && (
          <div className="placeholder">Select a horoscope to edit</div>
        )}

        {active && (
          <>
            <h3>
              Editing: {active.title} ({active.zodiac})
            </h3>

            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Enter horoscope reading..."
            />

            <button className="save-btn" onClick={saveItem} disabled={saving}>
              {saving ? "Saving…" : "Save"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
